import "./frontpage.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ga from "../../googleAnalytics";

export const FrontpageComponent = ({ language }) => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    ga.trackGAEvent("frontpage_button_click", "frontpage_buttons", "book_now");
    navigate("/booking");
  };
  return (
    <Container fluid className="d-flex flex-column frontpage-container">
      <Row className="flex-grow-1">
        <Col>
          <Button
            onClick={() => handleNavigate()}
            className="frontpage-btn"
            variant="outline-dark"
          >
            {language === "fin" && "Varaa nyt!"}
            {language === "eng" && "Book now!"}
            {language === "swe" && "Boka nu!"}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};
